import { useEffect, useState } from 'react';
import '../App.css';
import V2Card from '../V2Card';
import DeviceHeader from './DeviceHeader';
import { loadAllCampaigns } from '../QueryCampaign';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import AdCreative from '../AdCreative';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CampaignStatus from '../campaigns/CampaignStatus';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import V2Warning from './V2Warning';

function DeviceCampaigns({ menu }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [campaigns, setCampaigns] = useState([]);
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);

    const [edges, setEdges] = useState([]);
    const availableFilters = [
        {
            name: 'All Campaigns', code: 'all_campaigns',
        },
        {
            name: 'Active Campaigns', code: 'active_campaigns',
        },
        {
            name: 'Inactive Campaigns', code: 'inactive_campaigns',
        },
    ]

    const [filter, setFilter] = useState(availableFilters[0]);

    function loadEdges() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/campaigns/?device_id=${searchParams.get('device_id')}`,
        ).then(
            (response) => {
                setEdges(response.data.edges);
            }
        ).catch(
            (error) => {
                console.log(error);
                setEdges([]);
            }
        )
    }

    function getStatusForCampaign(campaign) {
        const filtered = edges.filter(
            edge => edge.campaign_uuid == campaign.uuid && edge.status == 'active'
        )
        if (filtered.length > 0) {
            return 'active';
        }
        return 'inactive';
    }

    function getStatus(campaign) {
        const status = getStatusForCampaign(campaign);
        return <div>
            <CampaignStatus status={status} />
        </div>;
    }

    function createEdge(campaign_id, device_id) {
        axios.post(
            process.env.REACT_APP_API_HOST + '/campaign/device/enable/',
            {
                campaign_id: campaign_id,
                device_id: device_id,
            },
        ).then(
            (response) => {
                loadEdges();
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function patchEdge(edge_id, data) {
        axios.patch(
            process.env.REACT_APP_API_HOST + `/campaignedgedevice/${edge_id}/`,
            data,
        ).then(
            (response) => {
                loadEdges();
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function getEdgeForCampaign(campaign) {
        const filtered = edges.filter(
            edge => edge.campaign_uuid == campaign.uuid && edge.status == 'active'
        )
        if (filtered.length == 0) {
            return null;
        }
        return filtered[0];
    }

    function getActions(campaign) {
        const status = getStatusForCampaign(campaign);
        if (status == 'active') {
            return <div>
                <Button
                    severity='danger'
                    label='Stop'
                    size='small'
                    outlined
                    onClick={
                        () => {
                            const edge = getEdgeForCampaign(campaign);
                            patchEdge(
                                edge.id,
                                {
                                    status: 'inactive'
                                }
                            )
                        }
                    }
                />
            </div>;
        }

        return <div>
            <Button
                severity='success'
                label='Start'
                size='small'
                outlined
                onClick={
                    () => createEdge(campaign.id, searchParams.get('device_id'))
                }
            />
        </div>;
    }

    useEffect(
        () => {
            loadAllCampaigns().then(
                (response) => {
                    setCampaigns(response.data);
                }
            ).catch(
                (error) => {
                    console.log(error);
                    setCampaigns([]);
                }
            );
            loadEdges();
        },
        [],
    )

    useEffect(
        () => {
            if (filter.code == 'all_campaigns') {
                setFilteredCampaigns(campaigns);
            }
            if (filter.code == 'active_campaigns') {
                const filtered_campaigns = campaigns.filter(
                    c => getStatusForCampaign(c) == 'active'
                )
                setFilteredCampaigns(filtered_campaigns);
            }
            if (filter.code == 'inactive_campaigns') {
                const filtered_campaigns = campaigns.filter(
                    c => getStatusForCampaign(c) == 'inactive'
                )
                setFilteredCampaigns(filtered_campaigns);
            }
        },
        [campaigns, edges, filter],
    )

    if (!campaigns || !edges) {
        return (
            <ProgressSpinner />
        );
    }

    return (
        <div align='center'>
            {menu}
            <DeviceHeader title='Campaigns' />
            <V2Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        {
                            campaigns.length == 0 &&
                            <div style={{ marginBottom: '1em' }}>
                                <V2Warning title="You don't have any campaigns right now." />
                            </div>
                        }
                        <Button
                            label='New Campaign'
                            severity='success'
                            outlined
                            size='small'
                            onClick={() => navigate('/campaigns/new')}
                            icon='pi pi-plus'
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '1em',
                            marginLeft: 'auto',
                        }}
                    >
                        <div style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <div style={{ marginRight: '1em' }}>
                                filter:
                            </div>
                            <Dropdown
                                value={filter}
                                onChange={(e) => setFilter(e.value)}
                                options={availableFilters}
                                optionLabel='name'
                                placeholder='select filter'
                            />
                        </div>
                    </div>
                </div>
            </V2Card>
            <V2Card>

                <DataTable
                    value={filteredCampaigns}
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                >
                    <Column
                        key={1}
                        header='Creative'
                        body={
                            (p) =>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={
                                        () => navigate(`/campaign?campaign_id=${p.id}`)
                                    }
                                >
                                    <div
                                        style={{
                                            width: '4em',
                                            marginRight: '1em',
                                        }}
                                    >
                                        <AdCreative
                                            creativeURL={p.creative_url}
                                            creativeExt={p.creative_ext}
                                            width='100%'
                                            height='100%'
                                            objectFit='contain'
                                        />
                                    </div>
                                    <div>
                                        {p.title}
                                    </div>
                                </div>
                        }
                    />
                    <Column
                        key={2}
                        header='Status'
                        field='status'
                        body={
                            (p) => getStatus(p)
                        }
                    />
                    <Column
                        key={2}
                        header='Actions'
                        field='status'
                        body={
                            (p) => getActions(p)
                        }
                    />
                </DataTable>
            </V2Card>
        </div>
    );
}

export default DeviceCampaigns;